import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
// import { Button, Typography, List, ListItem, Grid } from '@mui/material';
// import { Link as RouterLink } from 'react-router-dom';
import MovingOutInfoBlock from 'src/components/tenant/MovingOutInfoBlock';
import TenantInformation from 'src/components/tenant/TenantInformation';
import { Balance } from 'src/components/resident/Balance';
// import useStyles from '../styles';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { getIntervalBetweenDateAndNow } from 'src/utils/date';
import { BackdropLoader } from '@livable/saas-react-components';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { singleElementOfArray } from 'src/utils/singleElementOfArray';
export const OverviewTab = observer(_ref => {
  let residencyId = _ref.residencyId,
    accountId = _ref.accountId,
    propertyId = _ref.propertyId,
    changeGlobalTab = _ref.changeGlobalTab,
    isOpen = _ref.isOpen,
    parentToggleRefreshCallback = _ref.parentToggleRefreshCallback;
  const store = useStore();
  // const classes = useStyles();

  const balanceStatuses = ['success', 'due', 'critical'];
  const residencyOverview = store.residencies.residencyOverview;
  const _useState = useState(balanceStatuses[0]),
    _useState2 = _slicedToArray(_useState, 2),
    balanceStatus = _useState2[0],
    setBalanceStatus = _useState2[1];
  const _useState3 = useState({
      accountCode: 'N/A',
      email: 'N/A',
      newEmail: null,
      phone: 'N/A',
      lastName: 'N/A',
      firstName: 'N/A',
      emailConfirmed: true,
      portalAccessDateOnly: null
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    userProfileData = _useState4[0],
    setUserProfileData = _useState4[1];
  useEffect(() => {
    if (!isOpen) return;
    const getResidencyMoveOutDate = async data => {
      const resp = await store.residencies.getResidencyMoveOutDateAsync.run(data);
      return resp;
    };
    const getResidencyOverview = async data => {
      const resp = await store.residencies.getResidencyOverviewByResidencyIdAsync.run(data);
      return resp;
    };
    const getUserProfile = async data => {
      const resp = await store.account.getUsersProfilesAsync.run(data);
      return resp;
    };
    const getAccountBalance = async data => {
      const resp = await store.payment.getAccountBalanceAsync.run(data);
      return resp;
    };
    const getCurrentCycle = async () => {
      const resp = await store.allocations.getCurrentCycleAsync.run({
        companyId: localStorage.getItem(USER_SETTINGS_KEYS.company)
      });
      return resp;
    };
    const getAutopayMethodByAccountId = async data => {
      const resp = await store.payment.getAutopayMethodByAccountIdAsync.run(data);
      return resp;
    };
    Promise.all([getResidencyMoveOutDate({
      residencyId: residencyId
    }), getUserProfile({
      accountIds: [accountId]
    }), getResidencyOverview({
      residencyId: residencyId
    }), getAccountBalance({
      accountId: accountId
    }), getCurrentCycle(), getIntervalBetweenDateAndNow(store.payment.residentBalance.dueOnDateOnly), getAutopayMethodByAccountId({
      accountId: accountId
    })]).then(resp => {
      var _singleElementOfArray, _resp$, _singleElementOfArray2, _resp$2, _singleElementOfArray3, _resp$3, _singleElementOfArray4, _resp$4, _singleElementOfArray5, _resp$5, _singleElementOfArray6, _resp$6, _singleElementOfArray7, _resp$7, _singleElementOfArray8, _resp$8, _resp$9;
      if (!resp) {
        return;
      }
      setUserProfileData({
        email: (_singleElementOfArray = singleElementOfArray((_resp$ = resp[1]) === null || _resp$ === void 0 ? void 0 : _resp$.response)) === null || _singleElementOfArray === void 0 ? void 0 : _singleElementOfArray.email,
        newEmail: (_singleElementOfArray2 = singleElementOfArray((_resp$2 = resp[1]) === null || _resp$2 === void 0 ? void 0 : _resp$2.response)) === null || _singleElementOfArray2 === void 0 ? void 0 : _singleElementOfArray2.newEmail,
        emailConfirmed: (_singleElementOfArray3 = singleElementOfArray((_resp$3 = resp[1]) === null || _resp$3 === void 0 ? void 0 : _resp$3.response)) === null || _singleElementOfArray3 === void 0 ? void 0 : _singleElementOfArray3.emailConfirmed,
        firstName: (_singleElementOfArray4 = singleElementOfArray((_resp$4 = resp[1]) === null || _resp$4 === void 0 ? void 0 : _resp$4.response)) === null || _singleElementOfArray4 === void 0 ? void 0 : _singleElementOfArray4.firstName,
        accountCode: (_singleElementOfArray5 = singleElementOfArray((_resp$5 = resp[1]) === null || _resp$5 === void 0 ? void 0 : _resp$5.response)) === null || _singleElementOfArray5 === void 0 ? void 0 : _singleElementOfArray5.accountCode,
        lastName: (_singleElementOfArray6 = singleElementOfArray((_resp$6 = resp[1]) === null || _resp$6 === void 0 ? void 0 : _resp$6.response)) === null || _singleElementOfArray6 === void 0 ? void 0 : _singleElementOfArray6.lastName,
        phone: (_singleElementOfArray7 = singleElementOfArray((_resp$7 = resp[1]) === null || _resp$7 === void 0 ? void 0 : _resp$7.response)) === null || _singleElementOfArray7 === void 0 ? void 0 : _singleElementOfArray7.phone,
        portalAccessDateOnly: (_singleElementOfArray8 = singleElementOfArray((_resp$8 = resp[1]) === null || _resp$8 === void 0 ? void 0 : _resp$8.response)) === null || _singleElementOfArray8 === void 0 ? void 0 : _singleElementOfArray8.portalAccessDateOnly
      });
      setBalanceStatus((_resp$9 = resp[3]) === null || _resp$9 === void 0 ? void 0 : _resp$9.accountBalanceStatus);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [residencyId]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, store.residencies.moveOutDateOnly && /*#__PURE__*/React.createElement(MovingOutInfoBlock, {
    date: store.residencies.moveOutDateOnly,
    action: changeGlobalTab,
    isAppfolio: store.company.companyFeatureStore.isAppfolio
  }), /*#__PURE__*/React.createElement(TenantInformation, {
    accountId: accountId,
    action: changeGlobalTab,
    data: userProfileData,
    overviewData: residencyOverview,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }), /*#__PURE__*/React.createElement(Balance, {
    residentModal: {
      residencyId: residencyId,
      accountId: accountId,
      propertyId: propertyId
    },
    status: balanceStatus,
    handleRefreshTrigger: parentToggleRefreshCallback
  }), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.residencies.getResidencyMoveOutDateAsync.inProgress || store.residencies.getResidencyOverviewByResidencyIdAsync.inProgress || store.payment.getAccountBalanceAsync.inProgress || store.account.getUsersProfilesAsync.inProgress
  }));
});